// import Vue from 'vue'

// import historyData from './history_data'                   //历史数据
// import statisticalAnalysis from './statistical_analysis'   //统计分析
// import systemSetting from './system_setting'               //系统设置

import { getToken, removeStation } from '@/utils/auth.js'
import redirect from '@/utils/module.js'
export default function(){
	let array;
	let url = redirect.dashboard[process.env.MODULE]

	//如果是超级管理员，则重定向到对应的页面
	if(getToken() == 'administratorhzinfov4'){
		url = redirect.index[process.env.MODULE]
		removeStation();//超级管理员没有站点信息
	}
	array = [
		{ 
			path: '/', 
			hidden: true,
			redirect: url || '/system/user'
		},
		{
			path: '/commons/person_info',
			title: '个人设置',
			hidden: true
		},
		// {
		// 	path: '/commons/ppt',
		// 	title: 'PPT',
		// 	hidden: true
		// }
		{
			path: '/commons/multiple_screen',
			title: '多屏播放',
			hidden: true
		}
	];
	return array
}


// WEBPACK FOOTER //
// ./src/router/config.js